(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-hero-carousel"] && !Shopify.designMode) return;
  try {
    

function doCarousel() {
  $('.home-hero-js').slick({
    autoplay: true,
    dots: true,
    infinite: true,
    autoplaySpeed: '7000',
    speed: '900',
    fade: true
  });
}

jQuery(document).on('shopify:section:load', function(){
  doCarousel()
})


$(function() {
  $('.home-hero-js').slick({
    autoplay: true,
      dots: true,
     infinite: true,
      autoplaySpeed: '7000',
      speed: '900',
      fade: true
    });
});

  } catch(e) { console.error(e); }
})();
})();
